<template>
    <modal ref="modal">
        <template #body>
            <div class="text-center">
                <font-awesome-icon v-if="showTrashIcon" icon="fa-trash-can" class="text-red-600 text-2xl" />
                <div class="mt-4 mb-4" v-html="message"></div>
                <button type="button"
                    class="px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                    @click.prevent="close">Cancelar</button>
                <button type="button"
                    class="px-6 py-2.5 btn-purple text-white font-medium text-xs leading-tight uppercase rounded shadow-md btn-purple-200hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    @click.prevent="confirm">Confirmar</button>
            </div>

            <slot name="footer" :item="item"></slot>
        </template>
    </modal>
</template>
<script>
import { ref } from 'vue';
import Modal from '@/Shared/Modal'

export default {
    components: {
        Modal,
    },
    props: {
        // Exibe/oculta o ícone de lixeira no cabeçalho do modal
        showTrashIcon: { type: Boolean, default: true },
        // Props opcionais já usadas internamente via setup
        message: { type: [String], default: '' },
        url: { type: [String], default: '' },
        item: { type: [Object, String, Number, Array, Boolean, null], default: null },
        payload: { type: [Object, String, Number, Array, Boolean, null], default: null },
    },
    setup(props, context) {
        const message = ref(props.message);
        const url = ref(props.url);
        const item = ref(props.item);
        const payload = ref(props.payload)

        const modal = ref(null);

        const setPayload = data => {
            payload.value = data
        }

        const openModalDelete = (i, u, m) => {
            url.value = u;
            item.value = i;
            message.value = m;
            modal.value.showModal = true;
        }

        const closeModalDelete = () => {
            modal.value.showModal = false;
        }

        return {
            openModalDelete,
            closeModalDelete,
            setPayload,
            modal,
            item,
            url,
            message,
            payload
        }
    },
    methods: {
        confirm() {
            this.$inertia.delete(`${this.url}`, {
                data: this.payload,
                onFinish: () => {
                    this.$emit('confirm', this.item);
                    this.close();
                }
            });
        },
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
            this.$emit('close');
        }
    },
}
</script>
<style></style>